var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
    [
      _vm.currentView == "selectCount"
        ? [
            _c("SelectCameraCount", {
              attrs: { splitListCount: _vm.splitScreenList.length },
              on: {
                selectedCameraCount: _vm.selectedCameraCountFunc,
                selectCancel: _vm.selectCancelFunc,
              },
            }),
          ]
        : _vm.currentView == "selectCamera"
        ? [
            _c("SelectCamera", {
              attrs: { viewCount: _vm.selectedCameraCount },
              on: { cancel: _vm.cancelFunc, addSuccess: _vm.addSuccessFunc },
            }),
          ]
        : _vm.currentView == "selectSplitPlayer"
        ? [
            _c("SplitPlayer", {
              attrs: { viewCount: _vm.selectedCameraCount },
              on: {
                newSplit: _vm.newSplitFunc,
                changeViewCount: _vm.changeViewCountFunc,
                updateSplitScreenList: _vm.updateSplitScreenListFunc,
              },
            }),
          ]
        : [
            _c(
              "v-col",
              { staticClass: "ma-0 pa-10 mt-10", attrs: { cols: "12" } },
              [
                _c("v-progress-circular", {
                  attrs: {
                    indeterminate: "",
                    color: "white",
                    width: 6,
                    size: 50,
                  },
                }),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }